import { render, staticRenderFns } from "./ProjectBasemaps.vue?vue&type=template&id=15fde49a"
import script from "./ProjectBasemaps.vue?vue&type=script&lang=js"
export * from "./ProjectBasemaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports